<template>
  <div class="my-5">
    <custom-popup
      v-model="openCafeCharge"
      :cons="{ title: 'وارد کردن مبلغ' }"
      hide-confirm
      hide-overlay
      max-width="600"
    >
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2" cols="12">
          <price-input v-model="cafeChargeAmount" dense="" label="مبلغ" />
        </v-col>
      </v-row>

      <v-card-actions>
        <v-btn
          :disabled="!cafeChargeAmount"
          :loading="chargeLoading"
          class="btn-charge-wallet text-right"
          @click="charge"
        >
          <v-icon left>mdi-format-list-bulleted</v-icon>
          شارژ کافه بازار
        </v-btn>
      </v-card-actions>
    </custom-popup>

    <!-- Dialog for showing price input -->
    <custom-popup
      v-model="showPriceInputDialog"
      :cons="{ title: 'مبلغ مورد نظر را وارد کنید' }"
      hide-confirm
      hide-overlay
      max-width="600"
    >
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2" cols="12">
          <price-input v-model="enteredPrice" dense="" label="مبلغ" />
        </v-col>
      </v-row>

      <v-card-actions>
        <v-btn :disabled="!enteredPrice" class="btn-accept text-right" @click="handlePriceInput">
          <v-icon left>mdi-check</v-icon>
          تایید
        </v-btn>
        <v-btn class="btn-cancel text-right mr-2" @click="closePriceInputDialog">
          <v-icon left>mdi-close</v-icon>
          انصراف
        </v-btn>
      </v-card-actions>
    </custom-popup>

    <div class="d-flex align-center mb-4">
      <p class="ma-0">
        موجودی کل:
        <span class="font-weight-black" style="font-size: 11pt">{{ totalAmount }}</span>
        ﷼
      </p>
      <v-spacer />
      <v-btn class="btn-accept ma-0" :href="`${$coreApi}/#/payments`" target="_blank">
        <v-icon left>mdi-format-list-bulleted</v-icon>
        لیست شارژ
      </v-btn>
    </div>

    <vue-table :data="accounts" :headers="headers">
      <template v-slot:index="{ item }">
        {{ item.index + 1 }}
      </template>

      <template v-slot:amount_str="{ item }"> {{ price(item.amount) }} ریال </template>

      <template v-slot:max_charge="{ item }"> {{ price(item.max_charge) }} ریال </template>

      <template v-slot:status="{ item }">
        <div :class="!!item.status ? 'text-success' : 'text-danger'">
          {{ !!item.status ? 'فعال' : 'غیرفعال' }}
        </div>
      </template>

      <template v-slot:can_charge="{ item }">
        <div
          :class="!!item.can_charge ? 'badge-success cursor-pointer' : 'badge-danger'"
          class="badge"
          @click="changeCanCharge(item.phone)"
        >
          {{ !!item.can_charge ? 'فعال' : 'غیرفعال' }}
        </div>
      </template>

      <template v-slot:action="{ item }">
        <v-btn
          :disabled="!item.status"
          :loading="item.loading"
          color="orange"
          icon
          @click="getCredit(item.phone)"
        >
          <v-icon>mdi-reload</v-icon>
        </v-btn>

        <v-btn :disabled="!item.status" color="purple" icon @click="selectedAccount = item.phone">
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn>

        <v-btn
          :disabled="!item.status"
          color="green"
          icon
          @click="
            () => {
              chargeAccount = item.phone;
              openCafeCharge = true;
            }
          "
        >
          <v-icon>mdi-battery-plus</v-icon>
        </v-btn>

        <v-btn
          color="blue"
          icon
          @click="
            () => {
              selectedAccountForPrice = item.phone;
              showPriceInputDialog = true;
            }
          "
        >
          <v-icon>mdi-cash-multiple</v-icon>
        </v-btn>

        <v-btn color="red" icon @click="deleteAccount(item.phone)">
          <v-icon>mdi-trash-can</v-icon>
        </v-btn>
      </template>
    </vue-table>
    <v-divider />

    <trans-action-list v-if="showTransactions" :phone="selectedAccount" />

    <v-autocomplete
      v-model="tableProps.phone"
      :items="accounts.data"
      :loading="loading"
      clearable
      dense
      item-text="phone"
      item-value="phone"
      outlined
      placeholder="حساب‌ها"
    />

    <mixed-table
      :columns="columns"
      :data="data"
      :fetch-data="getTransActions"
      :reload-table="reloadTable"
      :tb-props="tableProps"
    />
  </div>
</template>

<script>
import MixedTable from '@/components/Table/MixedTable.vue';
import { Axios2, dataTableProps } from '@/main';
import TransActionList from '@/view/pages/monitoring/transActionList.vue';
import Vue from 'vue';
import PriceInput from '@/core/plugins/TitleRibbon/pages/pickers/priceInput.vue';
import { debounce } from '@/custom';

export default {
  name: 'Bazar',

  components: { PriceInput, TransActionList, MixedTable },

  data() {
    return {
      tableProps: dataTableProps.tableProps,
      accounts: {},
      selectedAccount: undefined,
      selectedAccountForPrice: undefined,
      showTransactions: false,
      showPriceInputDialog: false,
      enteredPrice: 0,
      headers: [
        { text: 'ردیف', value: 'index', sortable: false, align: 'center' },
        { text: 'شماره', value: 'phone', sortable: false, align: 'center' },
        { text: 'موجودی', value: 'amount_str', sortable: false, align: 'center' },
        { text: 'سقف تراکنش', value: 'max_charge', sortable: false, align: 'center' },
        { text: 'وضعیت خط', value: 'status', sortable: false, align: 'center' },
        { text: 'وضعیت شارژ', value: 'can_charge', sortable: false, align: 'center' },
        { text: 'مدیریت', value: 'action', sortable: false, align: 'center' },
      ],
      openCafeCharge: false,
      cafeChargeAmount: 0,
      chargeAccount: undefined,
      chargeLoading: false,
      columns: [
        {
          label: 'ردیف',
          name: 'id',
          searchable: true,
        },
        {
          label: 'حساب',
          name: 'phone',
          searchable: true,
        },
        {
          label: 'توکن بازار',
          name: 'id',
          searchable: true,
          transform: val => val.data.order_id,
        },
        {
          label: 'نام کاربر',
          name: 'user.name',
          transform: val => val.data.user.name + ' ' + val.data.user.lastName,
          searchable: true,
        },
        {
          label: 'شماره آگهی',
          name: 'number_phone',
          transform: val => val.data.number.phone,
          searchable: true,
        },
        {
          label: 'شناسه پرداخت',
          name: 'advertise_payment_id',
        },
        {
          label: 'شناسه اگهی',
          name: 'advertise_id',
          searchable: true,
        },
        {
          label: 'عنوان',
          name: 'title',
          transform: val => val.data.data.description,
          searchable: true,
        },
        {
          label: 'مبلغ',
          name: 'amount',
          transform: val => val.data.data.amountString,
          searchable: true,
        },
        {
          label: 'تاریخ ثبت',
          name: 'dateString',
          transform: val =>
            `<span dir="ltr">${val.data.data.dateString + ' ' + val.data.data.timeString}</span>`,
          searchable: true,
        },
      ],
      data: {},
      loading: false,
    };
  },

  created() {
    this.getAccounts();
    this.getTransActions();
  },

  computed: {
    totalAmount() {
      if (!this.accounts.data) return 0;

      return this.accounts.data
        .reduce((a, b) => {
          return a + Number(b.amount);
        }, 0)
        .toLocaleString();
    },
  },

  watch: {
    selectedAccount() {
      this.showTransactions = false;

      this.$nextTick(() => {
        this.showTransactions = true;
      });
    },
  },

  methods: {
    getAccounts() {
      return Axios2.get('/admin/bazaar').then(({ data }) => {
        let acc = {
          data: data.data.map(item => {
            return {
              ...item,
              loading: false,
            };
          }),
        };

        this.accounts = { ...acc };
        this.$nextTick(() => {
          acc.data.forEach(account => this.getCredit(account.phone));
        });
      });
    },
    getCredit(phone) {
      // let account = this.accounts.data.find(x => x.phone === phone);
      let index = this.accounts.data.findIndex(x => x.phone === phone);

      this.accounts.data[index].loading = true;

      Axios2.get('admin/bazaar/credit', {
        timeout: 1000 * 5,
        params: {
          phone,
        },
      })
        .then(({ data }) => {
          this.accounts.data[index].amount_str = data.data.user_balance_string;
          this.accounts.data[index].amount = data.data.user_balance;
        })
        .finally(() => {
          this.accounts.data[index].loading = false;
        });
    },
    getTransActions(query) {
      this.loading = true;

      Axios2.get('/admin/bazaar/new/transactions', {
        params: {
          ...this.tableProps,
          ...query,
        },
      })
        .then(({ data }) => {
          this.data = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    charge() {
      this.chargeLoading = true;

      Axios2.get(`admin/bazaar/charge?amount=${this.cafeChargeAmount}&phone=${this.chargeAccount}`)
        .then(res => {
          if (res.data.data.detail) {
            Vue.$toast.error(res.data.data.detail, {
              position: 'top',
            });
          } else window.open(res.data.data.redirectUrl, '_blank');
        })
        .finally(() => {
          this.chargeLoading = false;
        });
    },
    changeCanCharge(phone) {
      this.chargeLoading = true;

      Axios2.put(`admin/bazaar/charge?phone=${phone}`)
        .then(res => {
          this.getAccounts();
        })
        .finally(() => {
          this.chargeLoading = false;
        });
    },
    deleteAccount(phone) {
      Axios2.delete('admin/bazaar/delete', {
        params: {
          phone,
        },
      }).then(({ data }) => {
        this.getAccounts();
      });
    },
    reloadTable(props) {
      console.log('props: ', props);

      debounce(() => {
        this.getTransActions(props);
      }, 1000);
    },

    handlePriceInput() {
      // Call the API to set max charge for the selected account
      Axios2.put(`/admin/bazaar/max_charge`, {
        phone: this.selectedAccountForPrice,
        max_charge: this.enteredPrice,
      })
        .then(response => {
          // Show success message
          Vue.$toast.success('سقف تراکنش با موفقیت تنظیم شد', {
            position: 'top',
          });

          // Refresh the accounts data to reflect the change
          this.getAccounts();

          // Close the dialog after handling
          this.closePriceInputDialog();
        })
        .catch(error => {
          // Show error message
          Vue.$toast.error('خطا در تنظیم سقف تراکنش', {
            position: 'top',
          });
          console.error('Error setting max charge:', error);
        });
    },

    closePriceInputDialog() {
      this.showPriceInputDialog = false;
      this.selectedAccountForPrice = undefined;
      this.enteredPrice = 0;
    },
  },
};
</script>

<style></style>
